import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { useTheme } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import * as PracticeActions from "../../state/redux/practiceSession";
import * as TrialActions from "../../state/redux/trialSession";
import OmniToolbar from "./omniToolbar";
import PortalAvatar from "./portalAvatar";
import PortalBackNav from "./portalBackNav";

const PortalAppBar = props => {
  const { title = "Welcome", hideMenu = true } = props;

  const theme = useTheme();

  const currentDepth = window.location.pathname.split("/").length;

  return (
    <AppBar
      sx={{
        boxShadow: "none",
        borderBottom: `1px solid ${theme.palette.primary.light}`,
        paddingLeft: theme.spacing(1),
        zIndex: "998",
      }}
    >
      <OmniToolbar disableGutters={true}>
        {/* {currentDepth > 2 && <PortalBackNav />} */}
        <Box
          sx={[
            {
              display: "flex",
              flexDirection: "column",
              flexGrow: 1,
            },
            currentDepth > 2 && {
              marginLeft: `-${theme.spacing(1)}`,
            },
          ]}
        >
          <Typography
            variant="overline"
            noWrap
            component="div"
            sx={[hideMenu && { marginLeft: theme.spacing(1), marginBottom: 0 }, { flexGrow: 1 }]}
          >
            {title}
          </Typography>
          <Typography
            variant="h5"
            noWrap
            component="div"
            sx={[
              hideMenu && { marginLeft: theme.spacing(1), marginTop: `-${theme.spacing(1)}` },
              { flexGrow: 1 },
            ]}
          >
            {props.organizationODM ? props.organizationODM.omniData.name : "Welcome"}
          </Typography>
        </Box>
        <Box sx={{ flexGrow: 0 }}>
          <PortalAvatar />
        </Box>
      </OmniToolbar>
    </AppBar>
  );
};

const mapStateToProps = state => ({
  bpShowChat: state.userSession.bpShowChat,
  organizationODM: state.userSession.organizationODM,
});

const mapDispatchToProps = {
  setCurrentTrialRequest: TrialActions.setCurrentTrialRequest,
  setPracticeODMRequest: PracticeActions.setPracticeODMRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PortalAppBar));
